import {
    Paper,
    Grid,
    Stack,
    Typography,
    Chip,
    Button,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { CounterpartyDetails } from "../counterpartyApi";
import { CounterpartyRoleChip } from "./CounterpartyRoleChip";
import { Localized } from "@fluent/react";

type HeaderProps = {
    counterparty: CounterpartyDetails;
    onEdit: () => void;
};

export const CounterpartyHeader = ({
    counterparty,
    onEdit,
}: HeaderProps) => {
    const isVip = counterparty.tags?.includes("VIP");

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                backgroundColor: (theme) =>
                    theme.palette.mode === "light"
                        ? theme.palette.grey[100]
                        : theme.palette.grey[900],
            }}
        >
            <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                    <Stack spacing={1}>

                        {/* Tytuł + statusy */}
                        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                {counterparty.displayName}
                            </Typography>

                            {/* VIP */}
                            {isVip && (
                                <Stack direction="row" spacing={0.5} alignItems="center">
                                    <StarRoundedIcon sx={{ color: "#f5b301" }} />
                                    <Chip
                                        size="small"
                                        label={
                                            <Localized id="counterparties-vip">
                                                <span>_vip</span>
                                            </Localized>
                                        }
                                        sx={{
                                            backgroundColor: "#fff7d6",
                                            color: "#a66b00",
                                            fontWeight: 600,
                                        }}
                                    />
                                </Stack>
                            )}

                            {/* Archived */}
                            {counterparty.isArchived && (
                                <Chip
                                    size="small"
                                    icon={<ArchiveOutlinedIcon />}
                                    label={
                                        <Localized id="counterparties-archived">
                                            <span>_archived</span>
                                        </Localized>
                                    }
                                />
                            )}
                        </Stack>

                        {/* Subheader */}
                        <Typography variant="body2" color="text.secondary">
                            <Localized id="counterparties-legalName">
                                <span>_legalName</span>
                            </Localized>
                            {": "}
                            {counterparty.legalName ?? (
                                <span>—</span>
                            )}
                            {" • "}
                            <Localized id="counterparties-country">
                                <span>_country</span>
                            </Localized>
                            {": "}
                            {counterparty.countryCode ?? (
                                <span>—</span>
                            )}
                        </Typography>

                        {/* Role */}
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                            {counterparty.roles.length > 0 ? (
                                counterparty.roles.map((r) => (
                                    <CounterpartyRoleChip key={r} role={r} />
                                ))
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    <Localized id="counterparties-noRoles">
                                        <span>_noRoles</span>
                                    </Localized>
                                </Typography>
                            )}
                        </Stack>

                    </Stack>
                </Grid>

                {/* Akcja */}
                <Grid item>
                    <Button
                        variant="outlined"
                        startIcon={<EditOutlinedIcon />}
                        onClick={onEdit}
                    >
                        <Localized id="edit">
                            <span>_edit</span>
                        </Localized>
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
};